import React from 'react';
import ProtectedRoute from './protected';
import ProfilePage from '../pages/profile';
import NotificationPage from '../pages/notififcations';

export const ProfileRoutes = [
  <ProtectedRoute exact path='/profile' component={ProfilePage} />,
  <ProtectedRoute exact path='/notifications' component={NotificationPage} />,
]